<template lang="html">


    <div class="cover-popup row-center">
        <span class="close-cover" @click="$emit('close')"></span>
        <div class="popup">
          <a class="close" @click="$emit('close')">✕</a>
          <h2 class="title-pop">Subir memoria</h2>
          <dropzone @emit="setDoc" ref="dropzone" class="full"></dropzone>
          <a class="btn" @click="inscribirse" :loading="loadinginscripcion" :disabled="!!!inscripcion.ficheroBase64">Enviar</a>
        </div>
      </div>



</template>

<script lang="js">

    import { mapGetters, mapActions } from 'vuex';

    import dropzone from '@/components/parts/dropzone';
    
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

	export default {
        name: 'popup-memoria-evento',
        props : ['id'],
        mounted(){
                this.inscripcion.urlAcceso = this.id;
        },
		data() {
			return {
                clicked : false,
                loadinginscripcion: false,
                inscripcion : {
                    ficheroBase64: "",
                    extension: "",
                    nombre: "",
                    urlAcceso: ""
                }
			}
        },
        methods : {
            ...mapActions(['subirMemoriaEvento']),
            inscribirse(){
                if(!!this.inscripcion.ficheroBase64){
                    this.loadinginscripcion = true;
                    this.subirMemoriaEvento(this.inscripcion).then(r => {
                        this.loadinginscripcion = false;
                        this.$emit('close');
                    })
                }
            },
            setDoc(value){
                for(let i in this.inscripcion){
                    this.inscripcion.nombre = value.nombre;
                    this.inscripcion.extension = value.extension_adjunto;
                    this.inscripcion.ficheroBase64 = value.ficheroB64ParaAltas;
                }
            }
        },
        components : {
            'dropzone' : dropzone,
        }
	}
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/parts/popup-subir-memoria-evento.vue